import React, { useMemo } from "react"
import { ChatConnectionStatus } from "../reducers/chatsSlice"
import ChatStatusBar from "./ChatStatusBar"
import { Icon } from "@blueprintjs/core"
import { useAppSelector } from "@/reducers/hooks"
import { selectWhatsappNumber } from "@/reducers/serviceConfigSlice"
import { Trans, useTranslation } from "react-i18next"

type ChatConnectionStatusBarProps = {
  status?: ChatConnectionStatus
  whatsappUnreachable?: boolean
}

const ChatConnectionStatusBar = ({
  status,
  whatsappUnreachable,
}: ChatConnectionStatusBarProps) => {
  const { t } = useTranslation()
  const whatsappNumber = useAppSelector(selectWhatsappNumber)
  const message = useMemo(() => {
    if (whatsappUnreachable) {
      return (
        <p>
          {whatsappNumber ? (
            <Trans
              i18nKey="app.chatConnection.whatsappUnreachableWithNumber"
              values={{ number: whatsappNumber }}
              components={{ b: <strong /> }}
            />
          ) : (
            t("app.chatConnection.whatsappUnreachable")
          )}
        </p>
      )
    }

    switch (status) {
      case "disconnected":
        return <p>{t("app.chatConnection.disconnected")}</p>
      case "failed":
        return (
          <span className="flex flex-col items-center gap-2 md:flex-row">
            <p>{t("app.chatConnection.failed")}</p>
            <button
              onClick={() => window.location.reload()}
              className="flex items-center space-x-1.5 rounded-md border border-warning-200 bg-warning-50 p-0.5 px-2 transition-transform active:translate-y-0.5"
            >
              <Icon icon="repeat" size={12} />{" "}
              <span>{t("app.chatConnection.refresh")}</span>
            </button>
          </span>
        )
      default:
        return null
    }
  }, [status, whatsappUnreachable, whatsappNumber, t])

  if (message) return <ChatStatusBar>{message}</ChatStatusBar>
  else return null
}

export default ChatConnectionStatusBar
